<template>
  <v-row v-if="dialog" justify="center">
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5 switchq--text">
          {{ $t("pushNot") }}</v-card-title
        >
        <v-card-text>
          <div class="font-weight-bold">
            {{ $t("pushMsg") }}
          </div>
          <small>
            {{ $t("pushMsg2") }}
          </small>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="switchq lighten-1 switchqSub--text"
            text
            @click="subscribe(), (dialog = false)"
            class="font-weight-bold"
            >{{ $t("confirm") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="denyPush(), (dialog = false)"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import PushMixin from "@/mixins/pushNotificationMixin";
export default {
  props: ["show"],
  mixins: [PushMixin],
  data() {
    return {
      dialog: false,
      publicVapidKey:
        "BM0y8CuzwW3kHMzRmTMDz_t2b5y7VWEV9MDk7i0eeEWioo2pJd9SclJsB6Bgi8sB2YFpGvTz-Lqf785cYIfFV6o",
    };
  },
  mounted() {
    if (this.$isKioskSession) return;

    setTimeout(() => {
      if (this.$isKioskSession) return;

      if (!this.isPushSupported()) return;

      if (window.Notification.permission === "default") {
        if (localStorage.getItem("deniedPush") != "true") {
          if (this.checkPushValid()) {
            this.dialog = true;
          }
        }
      }
    }, 2000);
  },
  methods: {
    isPushSupported() {
      return (
        typeof window !== "undefined" &&
        typeof navigator !== "undefined" &&
        "Notification" in window &&
        "serviceWorker" in navigator &&
        "PushManager" in window
      );
    },
    checkPushValid() {
      if (this.isPushSupported()) {
        this.dialog = true;
        return true;
      }
      return false;
    },
  },
};
</script>
